import React from 'react'
import ReactDOM from 'react-dom'
import firebase from 'firebase'
import './index.css'
import App from 'components/App'

var config = {
  apiKey: 'AIzaSyA9Xg-506I965MnVrDqkTrkslP_tNedrIs',
  authDomain: 'stupid-matkasse.firebaseapp.com',
  databaseURL: 'https://stupid-matkasse.firebaseio.com',
  projectId: 'stupid-matkasse',
  storageBucket: '',
  messagingSenderId: '91563056509'
}
firebase.initializeApp(config)

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js